import elementsApi from "@/api/elementsApi"
import UseSearchString from "@/composables/UseSearchString"

export default {
  namespaced: true,
  state: {
    common: {
      categories: [],
      elements: [],
      unitValues: []
    },
    errors: {},
    currentHouseElements: [],
    loadStatuses: {
      isHouseElementsLoading: true,
      isAddElementLoading: false,
      isEditElementLoading: false,
      isDeleteElementLoading: false
    },
    selectedElement: undefined,
    searchItems: {
      addElementFilterItemsValue: '',
      searchHouseElement: '',
    }
  },
  getters: {
    getHouseElements: state => {
      return state.currentHouseElements.map(i => {
        const currentElement = state.common.elements.find(el => el.id === i.element)
        return {
          id: i.id,
          value: i.value,
          elementName: currentElement.name,
          elementId: i.element,
          categoryId: currentElement.category,
          unit: state.common.unitValues[currentElement.unit]
        }
      })
    },

    getCurrentHouseElements: (state, getters) => {
      const categories = []

      const commonCategories = [...state.common.categories]

      if (getters.getHouseElements.find(i => i.categoryId === null)) {
        commonCategories.push({
          name: 'Прочее',
          id: null
        })
      }

      commonCategories.forEach(category => {
        const elements = getters.getHouseElements.filter(el => el.categoryId === category.id)

        if (elements.length > 0) {
          if (state.searchItems.searchHouseElement) {
            const searchInput = state.searchItems.searchHouseElement
            const filteredElement = elements
              .filter(i => i.elementName.toLowerCase().includes(searchInput.toLowerCase()))
              .map(i => ({
                ...i,
                elementName: `${category.name} ->
                  ${UseSearchString.fillSearchResult(i.elementName, searchInput)}`
              }))
            categories.push(...filteredElement)
          } else {
            categories.push({
              ...category,
              elements,
            })
          }
        }
      })

      return categories
    },

    getFreeElements: state => {
      const categories = []

      const commonCategories = [...state.common.categories]
      if (state.common.elements.find(i => i.category === null)) {
        commonCategories.push({
          name: 'Прочее',
          id: null
        })
      }

      commonCategories.forEach(category => {

        if (!state.currentHouseElements) {
          return undefined
        }

        const elements = state.common.elements.filter(el =>
          el.category === category.id &&
          state.currentHouseElements.find(i => i.element === el.id) === undefined
        )

        if (elements.length > 0) {
          if (state.searchItems.addElementFilterItemsValue) {
            const searchInput = state.searchItems.addElementFilterItemsValue
            const filteredElements = elements
              .filter(i => i.name.toLowerCase().includes(searchInput.toLowerCase()))
              .map(i => ({
                ...i,
                name: `${category.name} ->
              ${UseSearchString.fillSearchResult(i.name, searchInput)}`
              }))
            categories.push(...filteredElements)
          } else {
            categories.push({
              ...category,
              elements
            })
          }
        }
      })

      return categories
    },

    getSelectedElementData: (state, getters) => {
      if (!state.selectedElement || !state.currentHouseElements) {
        return undefined
      }

      const selectedElement = state.currentHouseElements.find(i => i.id === state.selectedElement)

      if (!selectedElement) {
        return undefined
      }

      return {
        value: selectedElement.value,
        unit: getters.getUnitValueByCode(state.common.elements.find(i => selectedElement.element === i.id).unit)
      }
    },

    getUnitValueByCode: state => code => state.common.unitValues[code]

  },
  mutations: {
    setCategories(state, payload) {
      state.common.categories = payload
    },
    setElements(state, payload) {
      state.common.elements = payload
    },
    setUnitValues(state, payload) {
      state.common.unitValues = payload
    },
    setCurrentHouseElements(state, payload) {
      state.currentHouseElements = payload
    },
    setCurrentHouseElementAfterEdit(state, payload) {
      state.currentHouseElements = state.currentHouseElements.map(i => i.id === payload.id ? {...i, ...payload} : i)
    },
    setCurrentHouseElementAfterAdd(state, payload) {
      state.currentHouseElements = [...state.currentHouseElements, payload]
    },
    setCurrentHouseElementAfterDelete(state, payload) {
      state.currentHouseElements = state.currentHouseElements.filter(i => i.id !== payload)
    },
    setLoadStatus(state, payload) {
      state.loadStatuses = Object.assign(state.loadStatuses, payload)
    },
    setSelectedElement(state, payload) {
      state.selectedElement = payload
    },
    setAddElementFilterItemsValue(state, payload) {
      state.searchItems.addElementFilterItemsValue = payload
    },
    setSearchHouseElement(state, payload) {
      state.searchItems.searchHouseElement = payload
    },
    setErrors(state, payload) {
      state.errors = payload
    }
  },
  actions: {
    loadElementsData({commit, rootState}) {
      commit('setLoadStatus', {isHouseElementsLoading: true})
      return elementsApi.getCategories()
        .then(response => {
          commit('setCategories', response)
          return elementsApi.getElements()
        }).then(response => {
          commit('setElements', response)
          return elementsApi.getUnitValues()
        }).then(response => {
          commit('setUnitValues', response)
          const link = rootState.house.houseForm.links.find(i => i.rel === 'elements' && i.action === 'GET').href
          return elementsApi.getHouseElements(link)
        }).then(response => {
          commit('setCurrentHouseElements', response)
          commit('setLoadStatus', {isHouseElementsLoading: false})
        })
    },

    loadUnitValues({commit}) {
      return elementsApi.getUnitValues()
        .then(response => commit('setUnitValues', response))
    },

    addElement({commit, rootState}, elementForm) {
      commit('setLoadStatus', {isAddElementLoading: true})
      const link = rootState.house.houseForm.links.find(i => i.rel === 'elements' && i.action === 'POST').href
      return elementsApi.addElement(link, elementForm)
        .then(response => {
          commit('setCurrentHouseElementAfterAdd', response)
          commit('setLoadStatus', {isAddElementLoading: false})
          commit('messages/addSuccess', 'Элемент успешно добавлен', {root: true})
        }).catch(reject => {
          commit('setErrors', reject.response.data)
          commit('setLoadStatus', {isAddElementLoading: false})
          throw reject
        })
    },

    editElement({commit, state}, elementForm) {
      commit('setLoadStatus', {isEditElementLoading: true})
      const link = state.currentHouseElements
        .find(i => i.id === state.selectedElement).links
        .find(i => i.rel === 'passportelement' && i.action === 'HEAD').href
      return elementsApi.editElement(link, elementForm)
        .then(response => {
          commit('setCurrentHouseElementAfterEdit', response)
          commit('setLoadStatus', {isEditElementLoading: false})
          commit('messages/addSuccess', 'Элемент успешно изменен', {root: true})
        }).catch(reject => {
          commit('setErrors', reject.response.data)
          commit('setLoadStatus', {isEditElementLoading: false})
          throw reject
        })
    },

    deleteElement({commit, state}) {
      commit('setLoadStatus', {isDeleteElementLoading: true})
      const link = state.currentHouseElements
        .find(i => i.id === state.selectedElement).links
        .find(i => i.rel === 'passportelement' && i.action === 'HEAD').href
      return elementsApi.deleteElement(link)
        .then(() => {
          commit('setCurrentHouseElementAfterDelete', state.selectedElement)
          commit('setSelectedElement', undefined)
          commit('setLoadStatus', {isDeleteElementLoading: false})
          commit('messages/addSuccess', 'Элемент успешно удален', {root: true})
        })
    }
  }
}
